module.exports = __webpack_public_path__ + "img/BGyellow.612a0371.png";